<template>
	<div
		ref="canvasWrapper"
		class="customizer-wrapper"
	>
		<canvas
			ref="canvas"
		/>

		<div
			ref="overlay"
			class="overlay"
		>
			<div v-if="zoom" class="wrapper__zoom-panel">
				<button
					type="button"
					:disabled="!zoom.isInAvailable"
					class="round-button"

					@click="zoomIn"
				>
					<span class="visually-hidden">Zoom in</span>
					<svg viewBox="0 0 24 24" width="24" height="24" fill="none">
						<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12h18m-9-9v18"/>
					</svg>

				</button>
				<button
					type="button"
					:disabled="!zoom.isOutAvailable"
					class="round-button"

					@click="zoomOut"
				>
					<span class="visually-hidden">Zoom out</span>
					<svg viewBox="0 0 24 24" width="24" height="24" fill="none">
						<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12h18"/>
					</svg>

				</button>

				<ARBtn
					@show-ar-pop-up="$emit('show-ar-pop-up')"
				/>
			</div>


			<div class="icon grab-icon-wrapper grab-icon" >
				<svg class="grab-icon-wrapper_icon" width="64" height="69" fill="none"><use href="#grab-icon-64" /></svg>
			</div>

			<div class="point point-filter">
				<button
					class="point__button"
					type="button"

					@click="$emit('show-demo-notify')"
				>
					<span class="plus">+</span> Color Filter
				</button>
			</div>

			<div class="point point-strap">
				<button
					class="point__button"
					type="button"

					@click="$emit('show-demo-notify')"
				>
					<span class="plus">+</span> Camera Strap
				</button>
			</div>
		</div>

	</div>
</template>

<script>
import useCustomizer from '@/composables/Customizer/index';
import provider from '@/composables/Customizer/provider';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import ARBtn from '@/components/Customizer/ARBtn';

const EVENTS = [
	'click',
	'controls-changed',
	'error',
	'loading',
	'fetching',
	'performance-check-done',
	'place-size',
	'ready',
	'hover',
];

export default {
	name: 'CustomizerWrapper',
	components: {
		ARBtn,
	},

	setup() {
		const canvasWrapper = ref(null);
		const canvas = ref(null);
		const overlay = ref(null);

		const {
			createThreeApp,
			initThreeApp,
			config,
			objectsState,
			loadingState,
		} = useCustomizer();

		const zoom = ref(null);

		const zoomIn = () => {
			console.info('zoomIn');
			provider.app.zoom({ in: true });
		};

		const zoomOut = () => {
			console.info('zoomOut');
			provider.app.zoom({ out: true });
		};


		const init = async () => {
			const $app = await createThreeApp(
				canvas.value,
				canvasWrapper.value,
				config.value,
				objectsState.value,
				overlay.value,
			);


			EVENTS.forEach((eventName) => {
				$app.on(eventName, (payload) => {
					console.debug(eventName, payload);
					if (eventName === 'controls-changed') {
						zoom.value = payload.zoom;
					} else if (eventName === 'loading') {
						loadingState.value = { type: 'loading', progress: payload };
					} else if (eventName === 'fetching') {
						loadingState.value = { type: 'fetching', progress: payload };
					} else if (eventName === 'ready') {
						loadingState.value = { type: 'benchmark', progress: payload };
					} else if (eventName === 'performance-check-done') {
						loadingState.value = { type: 'loaded' };
					} else if (eventName === 'click') {
						// handleAreaClick({
						// 	object: payload.objectId,
						// 	area: payload.areaId,
						// });
					} else if (eventName === 'hover') {
						// hover.value = payload;
					}
				});
			});

			await initThreeApp();
		};

		const destroy = () => {
			provider.destroy();
		};

		onMounted(init);
		onBeforeUnmount(destroy);

		return {
			canvasWrapper,
			canvas,
			overlay,
			zoom,
			zoomIn,
			zoomOut,
		};


	},
};
</script>

<style lang="sass" scoped>
@import "@/assets/styles.sass"

.customizer-wrapper
	position: absolute
	top: 0
	left: 0
	width: 100%
	height: 100%

.overlay
	position: absolute
	top: 0
	left: 0
	width: 100%
	height: 100%
	touch-action: none
	pointer-events: none

	.icon
		position: absolute
		z-index: 1
		touch-action: none
		pointer-events: none
		top: 50%
		left: 50%

	.grab-icon-wrapper
		height: 64px
		width: 64px
		opacity: 0


.point
	position: absolute
	top: calc(50% - 16px)
	left: calc(50% - 16px)


.point__button
	display: flex
	align-items: center
	padding: 4px 10px
	gap: 5px

	background: #FFFFFF
	border-radius: 100px
	border: none
	outline: none

	font-weight: 400
	font-size: 14px
	letter-spacing: -0.015em

	color: #000000

	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08)

	opacity: 0
	transform: scale(0, 0)

	cursor: pointer


	.plus
		font-size: 20px



.point--visible
	.point__button
		transition: transform 0.2s ease, opacity .2s ease .1s
		transform: scale(1, 1)
		opacity: 1
		touch-action: auto
		pointer-events: auto

		&:hover
			transform: scale(1.1, 1.1)


.wrapper__zoom-panel
	position: absolute
	transform: translateZ(0)
	left: 40px
	top: calc(50% - 60px)
	display: grid
	align-items: center
	justify-content: center
	gap: 20px

	@media (max-width: 650px)
		display: none

	& > *
		pointer-events: auto


.round-button
	width: 50px
	height: 50px
	position: relative
	display: inline-flex
	align-items: center
	justify-content: center
	border-radius: 50%
	background: white
	border: none
	cursor: pointer
	color: #000000
	transition: color .25s ease, background-color .25s ease

	&:active
		background-color: #898989

	&:disabled
		color: #707070
		background-color: #f6f6f6
		cursor: default

	&::before
		content: ''
		z-index: 0
		position: absolute
		width: 100%
		height: 100%
		border-radius: inherit
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08)

	& > svg
		display: block

</style>
